<template>
  <div class="page">
    <div class="apply">
      已有<span>{{ applyNumber }}</span
      >个应用
    </div>
    <div class="already">
      <div class="pay">
        <img src="http://cdn.chinachdu.com/webStatic/pay-platform/apply1.png" alt="" />
        <span>聚合支付</span>
      </div>
      <div class="open">
        已开通<span>{{ diffDay }}</span
        >天
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      applyNumber: '', //应用数
      diffDay: '', //开通天数
    };
  },
  mounted() {
    this.applyNumber = JSON.parse(localStorage.getItem('loginUesr')).applyNumber;
    this.diffDay = JSON.parse(localStorage.getItem('loginUesr')).diffDay;
  },
};
</script>

<style lang="less" scoped>
.page {
  @import '~@/assets/style/var.less';
  width: 100%;
  height: 76px;
  padding: 16px 0 12px;
  background: @bg-white;
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #333;
}
.apply {
  height: 76px;
  line-height: 76px;
  padding: 0 50px;
  border-right: 1px solid #ebebeb;
  span {
    color: #ff9f07;
    font-size: 28px;
    padding: 0 16px;
  }
}
.already {
  height: 76px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 50px;
  .open {
    font-size: 18px;
    color: #666;
    span {
      color: #ff9f07;
      font-size: 22px;
      padding: 0 10px;
    }
  }
  .pay {
    display: flex;
    align-items: center;
    img {
      height: 25px;
      margin-right: 16px;
    }
  }
}
</style>
